import * as React from "react";
const PageDataContext = React.createContext({
  appointmentDisplayType: "single"
});
const PageDataProvider = ({
  children,
  ...rest
}) => {
  const { Provider } = PageDataContext;
  return /* @__PURE__ */ React.createElement(Provider, { value: rest }, children);
};
const usePageData = () => React.useContext(PageDataContext);
export {
  PageDataProvider,
  usePageData
};
//# sourceMappingURL=PageDataContext.js.map
